var _rect, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.607666,
    y: 0.969604,
    width: 61.9418,
    height: 61.9418,
    rx: 14.8246,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_53_3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.1415,
    cy: 13.6137,
    r: 5.82481,
    fill: "#0057BE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3647 21.945L31.544 21.7117L25.263 24.9127L21.9262 30.3732L21.6338 42.0784L21.7415 55.8081L27.6184 54.6631L32.3291 50.5207L33.5068 45.8133V33.1976L38.6859 31.3711L43.7491 26.9211L44.3647 21.945Z",
    fill: "#E9D200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9536 21.7117H44.9331L43.7681 26.8972L39.1083 31.7123L25.7112 35.0458L21.6339 42.4537V30.2307L24.5463 25.0452L30.9536 21.7117Z",
    fill: "#FFE500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_53_3",
    x: 27.3167,
    y: 7.78894,
    width: 11.6497,
    height: 12.2455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.595857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.297928
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_53_3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d8c6e10daba9007f7b0fb180045ff9b1.svg";
export { ForwardRef as ReactComponent };